import React from 'react';
import { IconBox, IconProps } from '@summer/jst-react-icon';

const Play = (props: Omit<IconProps, 'ref'>) => (
  <IconBox {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 0L64.1773 32L16 64V0ZM21.3589 9.9927V54.0073L54.4918 32L21.3589 9.9927Z"
    />
  </IconBox>
);

export default Play;
